// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/winner_checker.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Date } from "../google/type/date_pb";
import { file_google_type_date } from "../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/winner_checker.proto.
 */
export const file_v1_winner_checker: GenFile = /*@__PURE__*/
  fileDesc("Chd2MS93aW5uZXJfY2hlY2tlci5wcm90bxICdjEiaAoSQ2hlY2tXaW5uZXJSZXF1ZXN0EhQKDGN1c3RvbWVyX2lkcxgBIAMoBRIsChFjaGVja193aW5uZXJfZGF0ZRgCIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSDgoGcmVnaW9uGAMgASgJIjcKE0NoZWNrV2lubmVyUmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCBIPCgdtZXNzYWdlGAIgASgJMn8KFFdpbm5lckNoZWNrZXJTZXJ2aWNlEmcKC0NoZWNrV2lubmVyEhYudjEuQ2hlY2tXaW5uZXJSZXF1ZXN0GhcudjEuQ2hlY2tXaW5uZXJSZXNwb25zZSIngtPkkwIhOgEqIhwvYXBpL3YxL3dpbm5lci1jaGVja2VyL2NoZWNrQihaJmdpdGh1Yi5jb20vZHVjYnQvdHQtZ28vZ2VuL3Byb3RvL3YxO3YxYgZwcm90bzM", [file_google_api_annotations, file_google_type_date]);

/**
 * @generated from message v1.CheckWinnerRequest
 */
export type CheckWinnerRequest = Message<"v1.CheckWinnerRequest"> & {
  /**
   * @generated from field: repeated int32 customer_ids = 1;
   */
  customerIds: number[];

  /**
   * Date for checking winners
   *
   * @generated from field: google.type.Date check_winner_date = 2;
   */
  checkWinnerDate?: Date;

  /**
   * Optional: Filter by region (mb, mn, mt)
   *
   * @generated from field: string region = 3;
   */
  region: string;
};

/**
 * Describes the message v1.CheckWinnerRequest.
 * Use `create(CheckWinnerRequestSchema)` to create a new message.
 */
export const CheckWinnerRequestSchema: GenMessage<CheckWinnerRequest> = /*@__PURE__*/
  messageDesc(file_v1_winner_checker, 0);

/**
 * @generated from message v1.CheckWinnerResponse
 */
export type CheckWinnerResponse = Message<"v1.CheckWinnerResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message v1.CheckWinnerResponse.
 * Use `create(CheckWinnerResponseSchema)` to create a new message.
 */
export const CheckWinnerResponseSchema: GenMessage<CheckWinnerResponse> = /*@__PURE__*/
  messageDesc(file_v1_winner_checker, 1);

/**
 * @generated from service v1.WinnerCheckerService
 */
export const WinnerCheckerService: GenService<{
  /**
   * @generated from rpc v1.WinnerCheckerService.CheckWinner
   */
  checkWinner: {
    methodKind: "unary";
    input: typeof CheckWinnerRequestSchema;
    output: typeof CheckWinnerResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_winner_checker, 0);

